import useRedirectUrl from "@casino/legacy/client/components/Auth/hooks/useRedirectUrl";
import useAuthMetamaskUser from "@casino/legacy/client/features/Metamask/hooks/useAuthMetamaskUser";
import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import getAuthRedirectUrl from "@casino/legacy/client/shared/getAuthRedirectUrl/getAuthRedirectUrl";
import MetamaskOnboarding from "@metamask/onboarding";
import { useMetaMask } from "metamask-react";

const useMetamaskButton = () => {
  const { status, connect, account, ethereum } = useMetaMask();
  const { handleMetamaskAuth } = useAuthMetamaskUser();
  const { isDesktop } = useAgentData();
  const redirect = useRedirectUrl();
  const { asPath } = useRouter();

  const handleConnect = async () => {
    if (isDesktop && status === "unavailable") {
      return new MetamaskOnboarding().startOnboarding();
    }

    const data = await connect();

    if (!data?.length) {
      return "";
    }
    const accountAddress = data[0];
    const redirectUrl = getAuthRedirectUrl(asPath, redirect);
    return handleMetamaskAuth({
      values: { ethAddress: accountAddress },
      redirectUrl,
    });
  };

  const handleClick = async () => {
    handleConnect();
  };

  return { status, handleClick, handleConnect, account, ethereum };
};

export default useMetamaskButton;
